module.exports = __webpack_public_path__ + "assets/images/hdl_r.fa409702.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/hdl_r.png
// module id = 724
// module chunks = 1